import React from 'react';
import styles from './tabs.module.css';
import classNames from 'classnames';
export function Tab(props) {
    return React.createElement("nav", { className: classNames(styles.tabSliderHeader, 'caption2', 'kplr_tabSliderHeader') });
}
export default Tab;
